module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-3-33a7037c83cd777469a6bbd79608753c.png";